// Generated by scripts/mdi/import-questionnaires.mjs from MDI "MOTS-C 3.20.26 09.17.26" (d00f8c90-b2cd-4416-96b6-eebad2d28412). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiMOTSCAnswerField } from './questions';

export const mdiMOTSC: FormType<mdiMOTSCAnswerField> = {
  name: 'MOTS-C',
  validityLength: 25,
  questions: [
    {
      key: 'mdiMOTSC_sex',
      next: {
        switch: [
          {
            condition: { 'mdiMOTSC_sex.female': true },
            key: 'mdiMOTSC_pregnancy'
          },
          {
            condition: { 'mdiMOTSC_pregnancy.yes': true },
            key: 'mdiMOTSC_wereSorryBasedPreviousAnswer'
          }
        ],
        els: 'mdiMOTSC_importantClickAttachedLinkReview'
      }
    },
    {
      key: 'mdiMOTSC_pregnancy',
      next: {
        condition: { 'mdiMOTSC_pregnancy.yes': true },
        key: 'mdiMOTSC_wereSorryBasedPreviousAnswer',
        els: 'mdiMOTSC_importantClickAttachedLinkReview'
      }
    },
    'mdiMOTSC_wereSorryBasedPreviousAnswer',
    'mdiMOTSC_importantClickAttachedLinkReview',
    'mdiMOTSC_reasonInterestedPeptide',
    {
      key: 'mdiMOTSC_everUsedPeptideTherapiesPast',
      next: {
        condition: { 'mdiMOTSC_everUsedPeptideTherapiesPast.yes': true },
        key: 'mdiMOTSC_peptidesUsedPreviously',
        els: 'mdiMOTSC_everReactionSideEffectsPeptide'
      }
    },
    'mdiMOTSC_peptidesUsedPreviously',
    {
      key: 'mdiMOTSC_everReactionSideEffectsPeptide',
      next: {
        condition: { 'mdiMOTSC_everReactionSideEffectsPeptide.yes': true },
        key: 'mdiMOTSC_reactionSideEffect',
        els: 'mdiMOTSC_diagnosedRedFlagMedicalConditions'
      }
    },
    'mdiMOTSC_reactionSideEffect',
    'mdiMOTSC_diagnosedRedFlagMedicalConditions',
    'mdiMOTSC_confirmNotHistoryCancerKidney',
    {
      key: 'mdiMOTSC_takeRedFlagMedicationsSubstances',
      next: {
        condition: {
          'mdiMOTSC_takeRedFlagMedicationsSubstances.alcohol_use': true
        },
        key: 'mdiMOTSC_manyAlcoholicDrinksConsumePer',
        els: 'mdiMOTSC_allergyBenzylPeroxide'
      }
    },
    'mdiMOTSC_manyAlcoholicDrinksConsumePer',
    'mdiMOTSC_allergyBenzylPeroxide',
    'mdiMOTSC_lastTimePersonMedicalEvaluation',
    'mdiMOTSC_confirmUnderstandContactDoctorQuestions',
    'mdiMOTSC_firstMessageDoctor',
    'mdiMOTSC_complete'
  ]
};
